


















































































































































































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import {
  Donor,
  SystemCode,
  systemCodeApi,
  SystemCodeWithKey,
  Trader
} from '@/api'
import { systemParameterStore } from '@/utils/store-accessor'
import {
  CallNumberEditItem,
  ModalCallNumberEdit
} from '@/components/modals/ModalCallNumberEdit'
import { CODE_KEY } from '@/config'
import InputCollectionNo from '@/components/molecules/InputCollectionNo/InputCollectionNo.vue'

export interface RegistrationInfoEditTableItem {
  id: {
    input: string
    errorMessage: string
  }
  holdingBranchCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  buyDepartmentCode: string
  mark: string
  ndc: string
  book: string
  sub: string
  shelfType: {
    input: string
    shortName: string
    errorMessage: string
  }
  collectionType: {
    input: string
    shortName: string
    errorMessage: string
  }
  traderCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  donorCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  acceptOrderDate: {
    input: string
    errorMessage: string
  }
  acceptOrderPrice: {
    input: string
    errorMessage: string
  }
  acceptType: {
    input: string
    shortName: string
    errorMessage: string
  }
  handlingType: {
    input: string
    shortName: string
    errorMessage: string
  }
  appendixCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  equipType: string
  budgetYear: number
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  revision: number
  _reserveAssign?: boolean
}

const PRICE_PREFIX: string = '￥'

@Component({
  components: {
    InputCollectionNo,
    ModalCallNumberEdit,
    DataTable,
    InputCodeDonor,
    InputCodeTrader,
    InputDatePicker,
    InputCode
  }
})
export default class RegistrationInfoEditTable extends ComponentVue {
  @Ref()
  modalCallNumberEdit!: ModalCallNumberEdit

  @PropSync('items', {
    type: Array,
    required: true
  })
  tableItems!: RegistrationInfoEditTableItem[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean
  })
  isOrder!: boolean

  get libraryBranchSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.LIBRARY_BRANCH.KEY)
  }

  get shelfTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.SHELF_TYPE.KEY)
  }

  get collectionTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.COLLECTION_TYPE.KEY)
  }

  get acceptTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.ACCEPT_TYPE.KEY)
  }

  get handlingTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.HANDLING_TYPE.KEY)
  }

  get appendixSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.APPENDIX.KEY)
  }

  get cols(): Col[] {
    return [
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        required: !this.isOrder,
        items: [
          {
            name: 'id',
            headerText: `${this.isOrder ? '発注' : '資料'}番号`
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        required: true,
        items: [
          {
            name: 'holdingBranchCode',
            headerText: '所蔵館'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'callNumber',
            headerText: '請求記号'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'shelfType',
            headerText: '配架'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        required: !this.isOrder,
        items: [
          {
            name: 'collectionType',
            headerText: '資料区分'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'traderCode',
            headerText: '業者'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'donorCode',
            headerText: '寄贈者'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        required: this.isOrder,
        items: [
          {
            name: 'acceptOrderDate',
            headerText: this.isOrder ? '発注日' : '受入日'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'acceptOrderPrice',
            headerText: this.isOrder ? '発注額' : '受入価格'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'acceptType',
            headerText: '受入区分'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'handlingType',
            headerText: '取扱区分'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'appendixCode',
            headerText: '付録区分'
          }
        ]
      }
    ]
  }

  get concatenationNumber(): string {
    return systemParameterStore.callNumberConcatenationNumber
  }

  get acceptOrderPriceMask(): string {
    return '#'.repeat(7)
  }

  get pricePrefix(): string {
    return PRICE_PREFIX
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  setShortName(obj: any, systemCode: SystemCode | Trader | Donor): void {
    obj.shortName = systemCode.shortName
  }

  callNumber(mark: string, ndc: string, book: string, sub: string): string {
    const callNumberAry = [mark, ndc, book, sub]

    return callNumberAry.some(part => part !== '')
      ? callNumberAry.join(this.concatenationNumber)
      : '編集'
  }

  openModalCallNumberEdit(item: CallNumberEditItem, index: number): void {
    this.modalCallNumberEdit.open({
      editItem: item,
      onClickReflect: (item: CallNumberEditItem) => {
        this.tableItems[index].mark = item.mark
        this.tableItems[index].ndc = item.ndc
        this.tableItems[index].book = item.book
        this.tableItems[index].sub = item.sub
      }
    })
  }

  @Emit('convert:shelf-type')
  onConvertShelfType(index: number): number {
    return index
  }
}
